import React, { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../../../assets/images/pages/logo.png";
import {
  SUPER_ADMIN_CREATE_SUB_ADMIN_PROFILE,
  SUPER_ADMIN_CUSTOMER_MANAGEMENT,
  SUPER_ADMIN_CUSTOMER_PROFILE_LINK,
  SUPER_ADMIN_DASHBOARD,
  SUPER_ADMIN_EDIT_SUB_ADMIN_PROFILE_ID,
  SUPER_ADMIN_SUB_ADMIN_CUSTOMER_MANAGEMENT,
  SUPER_ADMIN_SUB_ADMIN_PROFILE_ID,
  SUPER_ADMIN_ADMIN_WALLET,
  SUPER_ADMIN_ADMIN_WALLET_DEPOSIT,
  SUPER_ADMIN_ADMIN_WALLET_MPIN_VERFICATION,
  SUPER_ADMIN_ADMIN_WALLET_DEPOSIT_SUCCESS,
  SUPER_ADMIN_MANAGE_LENDINGS,
  SUPER_ADMIN_MANAGE_LENDINGS_EDIT_LIST,
  SUPER_ADMIN_MANAGE_LENDINGS_PROFILE_VIEW,
  SUPER_ADMIN_VIEW_BORROW_REPORTS,
  SUPER_ADMIN_MANAGE_LENDINGS_LIST_TOKEN,
  SUPER_ADMIN_VIEW_BORROW_REPORT_LIST_TOKEN_PROFILE,
  SUPER_ADMIN_MANAGE_LENDINGS_DIRECT_LENDING,
  SUPER_ADMIN_ACTIVE_AND_CLOSED_BORROWINGS,
  SUPER_ADMIN_ACTIVE_AND_CLOSED_BORROWINGS_PROFILE,
  SUPER_ADMIN_TRANSACTION,
  SUPER_ADMIN_TRANSACTION_PROFILE,
  SUPER_ADMIN_MARKETPLACE,
  SUPER_ADMIN_COLLATERAL_MANAGEMENT,
  SUPER_ADMIN_ACTIVITY_LOG,
  SUPER_ADMIN_COMMISSION_MANAGMENT,
  SUPER_ADMIN_REPORTS_CUSTOMER,
  SUPER_ADMIN_REPORT_TRANSACTION,
  SUPER_ADMIN_MARKETPLACE_PROFILE,
  SUPER_ADMIN_JOIN_ACCOUNT,
  SUPER_ADMIN_JOIN_ACCOUNT_PROFILE
} from "../../../config/constants/routePathConstants";
import { useHistory } from "react-router-dom"

const SideBar = () => {
  const PATH_WIN = window.location.pathname;
  const history = useHistory();

  const [reportsToggle, setReportSToggle] = useState(false);
  const [walletToggle, setWalletToggle] = useState(false);
  const [lendingToggle, setLendingToggle] = useState(false);
  return (
    <section className="sidebar_parent">
      <div className="side">
        <div className="logo">
          <img src={Logo} alt="Logo" />
        </div>

        <div className="sidebar_content">
          <ul>
            <Link className="side_menu" to={SUPER_ADMIN_DASHBOARD}>
              <div
                className={`list ${PATH_WIN === SUPER_ADMIN_DASHBOARD ? "active" : ""
                  }`}
              >
                <span className="span_icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.75 10.5C3.55109 10.5 3.36032 10.4209 3.21967 10.2803C3.07902 10.1396 3 9.94888 3 9.74997V3.75146C3 3.55255 3.07902 3.36179 3.21967 3.22113C3.36032 3.08048 3.55109 3.00146 3.75 3.00146H9.75C9.94891 3.00146 10.1397 3.08048 10.2803 3.22113C10.421 3.36179 10.5 3.55255 10.5 3.75146V9.74997C10.5 9.94888 10.421 10.1396 10.2803 10.2803C10.1397 10.4209 9.94891 10.5 9.75 10.5H3.75ZM14.25 10.5C14.0511 10.5 13.8603 10.4209 13.7197 10.2803C13.579 10.1396 13.5 9.94888 13.5 9.74997V3.75146C13.5 3.55255 13.579 3.36179 13.7197 3.22113C13.8603 3.08048 14.0511 3.00146 14.25 3.00146H20.2485C20.4474 3.00146 20.6382 3.08048 20.7788 3.22113C20.9195 3.36179 20.9985 3.55255 20.9985 3.75146V9.74997C20.9985 9.94888 20.9195 10.1396 20.7788 10.2803C20.6382 10.4209 20.4474 10.5 20.2485 10.5H14.25ZM3.75 21C3.55109 21 3.36032 20.921 3.21967 20.7803C3.07902 20.6396 3 20.4489 3 20.25V14.25C3 14.0511 3.07902 13.8603 3.21967 13.7196C3.36032 13.579 3.55109 13.5 3.75 13.5H9.75C9.94891 13.5 10.1397 13.579 10.2803 13.7196C10.421 13.8603 10.5 14.0511 10.5 14.25V20.25C10.5 20.4489 10.421 20.6396 10.2803 20.7803C10.1397 20.921 9.94891 21 9.75 21H3.75ZM14.25 21C14.0511 21 13.8603 20.921 13.7197 20.7803C13.579 20.6396 13.5 20.4489 13.5 20.25V14.25C13.5 14.0511 13.579 13.8603 13.7197 13.7196C13.8603 13.579 14.0511 13.5 14.25 13.5H20.2485C20.4474 13.5 20.6382 13.579 20.7788 13.7196C20.9195 13.8603 20.9985 14.0511 20.9985 14.25V20.25C20.9985 20.4489 20.9195 20.6396 20.7788 20.7803C20.6382 20.921 20.4474 21 20.2485 21H14.25Z"
                      stroke="white"
                      strokeOpacity="0.44"
                      strokeWidth="1.5"
                    />
                  </svg>
                </span>
                <span className="span_text">
                  Dashboard
                </span>
              </div>
            </Link>

            <Link className="side_menu " to={SUPER_ADMIN_CUSTOMER_MANAGEMENT}>
              <div
                className={`list ${PATH_WIN === SUPER_ADMIN_CUSTOMER_MANAGEMENT ||
                  PATH_WIN.slice(0, 29) === SUPER_ADMIN_CUSTOMER_PROFILE_LINK
                  ? "active"
                  : ""
                  }`}
              >
                <span className="span_icon">
                  <svg
                    width="19"
                    height="23"
                    viewBox="0 0 19 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 13.6509V15.6509C6.4087 15.6509 4.88258 16.283 3.75736 17.4082C2.63214 18.5335 2 20.0596 2 21.6509H0C0 19.5291 0.842855 17.4943 2.34315 15.994C3.84344 14.4937 5.87827 13.6509 8 13.6509V13.6509ZM8 12.6509C4.685 12.6509 2 9.96588 2 6.65088C2 3.33588 4.685 0.650879 8 0.650879C11.315 0.650879 14 3.33588 14 6.65088C14 9.96588 11.315 12.6509 8 12.6509ZM8 10.6509C10.21 10.6509 12 8.86088 12 6.65088C12 4.44088 10.21 2.65088 8 2.65088C5.79 2.65088 4 4.44088 4 6.65088C4 8.86088 5.79 10.6509 8 10.6509ZM10.595 18.4629C10.4682 17.9293 10.4682 17.3734 10.595 16.8399L9.603 16.2669L10.603 14.5349L11.595 15.1079C11.9932 14.7308 12.4745 14.4526 13 14.2959V13.1509H15V14.2959C15.532 14.4539 16.012 14.7359 16.405 15.1079L17.397 14.5349L18.397 16.2669L17.405 16.8399C17.5316 17.3731 17.5316 17.9286 17.405 18.4619L18.397 19.0349L17.397 20.7669L16.405 20.1939C16.0068 20.571 15.5255 20.8492 15 21.0059V22.1509H13V21.0059C12.4745 20.8492 11.9932 20.571 11.595 20.1939L10.603 20.7669L9.603 19.0349L10.595 18.4629V18.4629ZM14 19.1509C14.3978 19.1509 14.7794 18.9928 15.0607 18.7115C15.342 18.4302 15.5 18.0487 15.5 17.6509C15.5 17.2531 15.342 16.8715 15.0607 16.5902C14.7794 16.3089 14.3978 16.1509 14 16.1509C13.6022 16.1509 13.2206 16.3089 12.9393 16.5902C12.658 16.8715 12.5 17.2531 12.5 17.6509C12.5 18.0487 12.658 18.4302 12.9393 18.7115C13.2206 18.9928 13.6022 19.1509 14 19.1509Z"
                      fill="white"
                      fillOpacity="0.5"
                    />
                  </svg>
                </span>
                <span className="span_text">
                  Customer Management
                </span>
              </div>
            </Link>
            <Link className="side_menu " to={SUPER_ADMIN_JOIN_ACCOUNT} >
              <div
                className={`list ${PATH_WIN === SUPER_ADMIN_JOIN_ACCOUNT ||
                  PATH_WIN.slice(0, 33) === SUPER_ADMIN_JOIN_ACCOUNT_PROFILE
                  ? "active"
                  : ""
                  }`}
              >
                <span className="span_icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"   strokeOpacity="0.5"/>
                    <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"   strokeOpacity="0.5"/>
                    <path d="M23 20.9999V18.9999C22.9993 18.1136 22.7044 17.2527 22.1614 16.5522C21.6184 15.8517 20.8581 15.3515 20 15.1299" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"   strokeOpacity="0.5"/>
                  
                    <path d="M16 3.12988C16.8604 3.35018 17.623 3.85058 18.1676 4.55219C18.7122 5.2538 19.0078 6.11671 19.0078 7.00488C19.0078 7.89305 18.7122 8.75596 18.1676 9.45757C17.623 10.1592 16.8604 10.6596 16 10.8799" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"   strokeOpacity="0.5"/>
                  </svg>
                </span>
                <span className="span_text">
                  Joint Account
                </span>
              </div>
            </Link>


            <Link className="side_menu " to={SUPER_ADMIN_MARKETPLACE}>
              <div
                className={`list ${PATH_WIN === SUPER_ADMIN_MARKETPLACE ||
                  PATH_WIN.slice(0, 32) === SUPER_ADMIN_MARKETPLACE_PROFILE ? "active" : ""

                  }`}
              >
                <span className="span_icon">
                  <svg
                    width="23"
                    height="21"
                    viewBox="0 0 23 21"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 11.8929V18.6509H21V20.6509H1V18.6509H2V11.8929C1.38437 11.482 0.879713 10.9254 0.53082 10.2726C0.181927 9.61986 -0.000407734 8.89105 6.84612e-07 8.15088C6.84612e-07 7.32388 0.224001 6.52688 0.633001 5.84788L3.345 1.15088C3.43277 0.998863 3.559 0.872628 3.71101 0.78486C3.86303 0.697092 4.03547 0.650883 4.211 0.650879H17.79C17.9655 0.650883 18.138 0.697092 18.29 0.78486C18.442 0.872628 18.5682 0.998863 18.656 1.15088L21.358 5.83288C21.9546 6.82375 22.1463 8.00641 21.8934 9.13502C21.6405 10.2636 20.9624 11.2514 20 11.8929ZM18 12.6229C17.3124 12.7 16.6163 12.6174 15.9659 12.3815C15.3155 12.1456 14.7283 11.7628 14.25 11.2629C13.8302 11.702 13.3258 12.0514 12.7672 12.2901C12.2086 12.5289 11.6075 12.6519 11 12.6519C10.3927 12.6522 9.7916 12.5294 9.23303 12.291C8.67445 12.0527 8.16996 11.7036 7.75 11.2649C7.27163 11.7646 6.68437 12.1473 6.03395 12.383C5.38353 12.6187 4.68749 12.7011 4 12.6239V18.6509H18V12.6239V12.6229ZM4.789 2.65088L2.356 6.86388C2.11958 7.44802 2.11248 8.09991 2.33613 8.68906C2.55978 9.27821 2.99768 9.76117 3.56218 10.0413C4.12668 10.3214 4.77614 10.378 5.38058 10.1997C5.98502 10.0214 6.49984 9.62148 6.822 9.07988C7.157 8.24288 8.342 8.24288 8.678 9.07988C8.8633 9.5443 9.1836 9.94248 9.59753 10.223C10.0115 10.5035 10.5 10.6534 11 10.6534C11.5 10.6534 11.9885 10.5035 12.4025 10.223C12.8164 9.94248 13.1367 9.5443 13.322 9.07988C13.657 8.24288 14.842 8.24288 15.178 9.07988C15.3078 9.39933 15.5022 9.68848 15.7491 9.92915C15.996 10.1698 16.2901 10.3568 16.6127 10.4784C16.9354 10.6 17.2797 10.6535 17.6241 10.6356C17.9684 10.6176 18.3053 10.5287 18.6136 10.3743C18.9219 10.2199 19.1949 10.0034 19.4155 9.73841C19.6361 9.47341 19.7995 9.16564 19.8955 8.83445C19.9914 8.50326 20.0178 8.15581 19.973 7.81393C19.9281 7.47205 19.8131 7.14315 19.635 6.84788L17.21 2.65088H4.79H4.789Z"
                      fill="white"
                      fillOpacity="0.5"
                    />
                  </svg>
                </span>
                <span className="span_text">
                  MarketPlace
                </span>
              </div>
            </Link>
            <Link to="#" className="side_menu  toggle ">
              <div
                className={reportsToggle ? "list list_active" : "list"}
                onClick={() => {
                  setReportSToggle(!reportsToggle);
                  setWalletToggle(false);
                  setLendingToggle(false);
                }}
              >
                <span className="span_icon ">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M7.5 13.5H13.5V15H7.5V13.5Z" fill="#74777F" />
                    <path d="M7.5 9.75H16.5V11.25H7.5V9.75Z" fill="#74777F" />
                    <path
                      d="M7.5 17.25H11.25V18.75H7.5V17.25Z"
                      fill="#74777F"
                    />
                    <path
                      d="M18.75 3.75H16.5V3C16.5 2.60218 16.342 2.22064 16.0607 1.93934C15.7794 1.65804 15.3978 1.5 15 1.5H9C8.60218 1.5 8.22064 1.65804 7.93934 1.93934C7.65804 2.22064 7.5 2.60218 7.5 3V3.75H5.25C4.85218 3.75 4.47064 3.90804 4.18934 4.18934C3.90804 4.47064 3.75 4.85218 3.75 5.25V21C3.75 21.3978 3.90804 21.7794 4.18934 22.0607C4.47064 22.342 4.85218 22.5 5.25 22.5H18.75C19.1478 22.5 19.5294 22.342 19.8107 22.0607C20.092 21.7794 20.25 21.3978 20.25 21V5.25C20.25 4.85218 20.092 4.47064 19.8107 4.18934C19.5294 3.90804 19.1478 3.75 18.75 3.75ZM9 3H15V6H9V3ZM18.75 21H5.25V5.25H7.5V7.5H16.5V5.25H18.75V21Z"
                      fill="#74777F"
                    />
                  </svg>
                </span>
                <span className="span_text arrow">
                  Reports
                  <span className="span_icon_arrow">
                    {reportsToggle ? (
                      <i className="far fa-chevron-up"></i>
                    ) : (
                      <i className="far fa-chevron-down down"> </i>
                    )}
                  </span>
                </span>
              </div>
              <ul className="toggle_unordered_list">
                <li
                  className={`toggle_list ${PATH_WIN === SUPER_ADMIN_REPORTS_CUSTOMER
                    ? "toggle_list_active"
                    : ""
                    } `}
                  onClick={() => history.push(SUPER_ADMIN_REPORTS_CUSTOMER)}
                >
                  <span>
                    Customers</span>
                </li>
                <li
                  className={`toggle_list ${PATH_WIN === SUPER_ADMIN_REPORT_TRANSACTION
                    ? "toggle_list_active"
                    : ""
                    } `}
                  onClick={() => history.push(SUPER_ADMIN_REPORT_TRANSACTION)}
                >
                  <span>Transactions
                  </span>
                </li>
              </ul>
            </Link>

            <Link to="#" className="side_menu toggle ">
              <div
                className={walletToggle ? "list list_active " : "list "}
                onClick={() => {
                  setWalletToggle(!walletToggle);
                  setReportSToggle(false);
                  setLendingToggle(false);
                }}
              >
                <span className="span_icon">
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.6 7.65088H21.9C22.1917 7.65088 22.4715 7.75624 22.6778 7.94377C22.8841 8.13131 23 8.38566 23 8.65088V20.6509C23 20.9161 22.8841 21.1705 22.6778 21.358C22.4715 21.5455 22.1917 21.6509 21.9 21.6509H2.1C1.80826 21.6509 1.52847 21.5455 1.32218 21.358C1.11589 21.1705 1 20.9161 1 20.6509V4.65088C1 4.38566 1.11589 4.13131 1.32218 3.94377C1.52847 3.75624 1.80826 3.65088 2.1 3.65088H18.6V7.65088ZM3.2 9.65088V19.6509H20.8V9.65088H3.2ZM3.2 5.65088V7.65088H16.4V5.65088H3.2ZM15.3 13.6509H18.6V15.6509H15.3V13.6509Z"
                      fill="white"
                      fillOpacity="0.5"
                    />
                  </svg>
                </span>
                <span className="span_text arrow">
                  Wallet Management
                  <span className="span_icon_arrow">
                    {walletToggle ? (
                      <i className="far fa-chevron-up"></i>
                    ) : (
                      <i className="far fa-chevron-down down"> </i>
                    )}
                  </span>
                </span>
              </div>
              <ul className="toggle_unordered_list">
                <li
                  className={
                    PATH_WIN === SUPER_ADMIN_ADMIN_WALLET ||
                      PATH_WIN === SUPER_ADMIN_ADMIN_WALLET_DEPOSIT ||
                      PATH_WIN === SUPER_ADMIN_ADMIN_WALLET_MPIN_VERFICATION ||
                      PATH_WIN === SUPER_ADMIN_ADMIN_WALLET_DEPOSIT_SUCCESS
                      ? "toggle_list toggle_list_active"
                      : "toggle_list"
                  }
                >
                  <span onClick={() => history.push(SUPER_ADMIN_ADMIN_WALLET)}>
                    Admin Wallet
                  </span>
                </li>
              </ul>
            </Link>

            <Link to="#" className="side_menu toggle ">
              <div
                className={lendingToggle ? "list list_active " : "list "}
                onClick={() => {
                  setLendingToggle(!lendingToggle);
                  setWalletToggle(false);
                  setReportSToggle(false);
                }}
              >
                <span className="span_icon">
                  <svg
                    width="23"
                    height="20"
                    viewBox="0 0 23 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4 7.65088C4.26522 7.65088 4.51957 7.75624 4.70711 7.94377C4.89464 8.13131 5 8.38566 5 8.65088C6.57114 8.64856 8.09698 9.17715 9.33 10.1509H11.5C12.833 10.1509 14.03 10.7309 14.854 11.6509H18C18.9453 11.6506 19.8712 11.9183 20.6705 12.4229C21.4698 12.9275 22.1097 13.6484 22.516 14.5019C20.151 17.6229 16.322 19.6509 12 19.6509C9.21 19.6509 6.85 19.0479 4.94 17.9929C4.87004 18.1859 4.74224 18.3527 4.57402 18.4705C4.40579 18.5882 4.20534 18.6512 4 18.6509H1C0.734784 18.6509 0.48043 18.5455 0.292893 18.358C0.105357 18.1705 0 17.9161 0 17.6509V8.65088C0 8.38566 0.105357 8.13131 0.292893 7.94377C0.48043 7.75624 0.734784 7.65088 1 7.65088H4ZM5.001 10.6509L5 15.6729L5.045 15.7049C6.84 16.9649 9.178 17.6509 12 17.6509C15.004 17.6509 17.799 16.4949 19.835 14.5209L19.968 14.3879L19.848 14.2879C19.3758 13.918 18.8034 13.6986 18.205 13.6579L18 13.6509H15.889C15.961 13.9729 16 14.3069 16 14.6509V15.6509H7V13.6509L13.79 13.6499L13.756 13.5719C13.5644 13.1714 13.2696 12.8292 12.9019 12.5803C12.5343 12.3315 12.107 12.185 11.664 12.1559L11.5 12.1509H8.57C8.10531 11.6756 7.55027 11.2981 6.93752 11.0405C6.32477 10.7829 5.66669 10.6504 5.002 10.6509H5.001ZM3 9.65088H2V16.6509H3V9.65088ZM17 3.65088C17.7956 3.65088 18.5587 3.96695 19.1213 4.52956C19.6839 5.09217 20 5.85523 20 6.65088C20 7.44653 19.6839 8.20959 19.1213 8.7722C18.5587 9.33481 17.7956 9.65088 17 9.65088C16.2044 9.65088 15.4413 9.33481 14.8787 8.7722C14.3161 8.20959 14 7.44653 14 6.65088C14 5.85523 14.3161 5.09217 14.8787 4.52956C15.4413 3.96695 16.2044 3.65088 17 3.65088ZM17 5.65088C16.7348 5.65088 16.4804 5.75624 16.2929 5.94377C16.1054 6.13131 16 6.38566 16 6.65088C16 6.9161 16.1054 7.17045 16.2929 7.35799C16.4804 7.54552 16.7348 7.65088 17 7.65088C17.2652 7.65088 17.5196 7.54552 17.7071 7.35799C17.8946 7.17045 18 6.9161 18 6.65088C18 6.38566 17.8946 6.13131 17.7071 5.94377C17.5196 5.75624 17.2652 5.65088 17 5.65088ZM10 0.650879C10.7956 0.650879 11.5587 0.96695 12.1213 1.52956C12.6839 2.09217 13 2.85523 13 3.65088C13 4.44653 12.6839 5.20959 12.1213 5.7722C11.5587 6.33481 10.7956 6.65088 10 6.65088C9.20435 6.65088 8.44129 6.33481 7.87868 5.7722C7.31607 5.20959 7 4.44653 7 3.65088C7 2.85523 7.31607 2.09217 7.87868 1.52956C8.44129 0.96695 9.20435 0.650879 10 0.650879ZM10 2.65088C9.73478 2.65088 9.48043 2.75624 9.29289 2.94377C9.10536 3.13131 9 3.38566 9 3.65088C9 3.9161 9.10536 4.17045 9.29289 4.35799C9.48043 4.54552 9.73478 4.65088 10 4.65088C10.2652 4.65088 10.5196 4.54552 10.7071 4.35799C10.8946 4.17045 11 3.9161 11 3.65088C11 3.38566 10.8946 3.13131 10.7071 2.94377C10.5196 2.75624 10.2652 2.65088 10 2.65088Z"
                      fill="white"
                      fillOpacity="0.5"
                    />
                  </svg>
                </span>
                <span className="span_text arrow">
                  Lending Admin
                  <span className="span_icon_arrow">
                    {lendingToggle ? (
                      <i className="far fa-chevron-up"></i>
                    ) : (
                      <i className="far fa-chevron-down down"> </i>
                    )}
                  </span>
                </span>
              </div>
              <ul className="toggle_unordered_list">
                <li
                  className={
                    PATH_WIN === SUPER_ADMIN_MANAGE_LENDINGS ||
                      PATH_WIN === SUPER_ADMIN_MANAGE_LENDINGS_LIST_TOKEN ||
                      PATH_WIN === SUPER_ADMIN_MANAGE_LENDINGS_EDIT_LIST ||
                      PATH_WIN.slice(0, 38) ===
                      SUPER_ADMIN_MANAGE_LENDINGS_EDIT_LIST ||
                      PATH_WIN === SUPER_ADMIN_MANAGE_LENDINGS_PROFILE_VIEW ||
                      PATH_WIN.slice(0, 41) ===
                      SUPER_ADMIN_MANAGE_LENDINGS_PROFILE_VIEW ||
                      PATH_WIN === SUPER_ADMIN_MANAGE_LENDINGS_DIRECT_LENDING
                      ? "toggle_list toggle_list_active"
                      : "toggle_list"
                  }
                >
                  <span onClick={() => history.push(SUPER_ADMIN_MANAGE_LENDINGS)}>
                    Manage Lendings</span>
                </li>
                <li
                  className={
                    PATH_WIN === SUPER_ADMIN_VIEW_BORROW_REPORTS ||
                      PATH_WIN ===
                      SUPER_ADMIN_VIEW_BORROW_REPORT_LIST_TOKEN_PROFILE
                      ? "toggle_list toggle_list_active"
                      : "toggle_list"
                  }
                >
                  <span onClick={() => history.push(SUPER_ADMIN_VIEW_BORROW_REPORTS)}>
                    View Borrow Reports</span>
                </li>
              </ul>
            </Link>

            <Link
              to={SUPER_ADMIN_ACTIVE_AND_CLOSED_BORROWINGS}
              className="side_menu "
            >
              <div
                className={`list ${PATH_WIN === SUPER_ADMIN_ACTIVE_AND_CLOSED_BORROWINGS ||
                  PATH_WIN.slice(0, 49) ===
                  SUPER_ADMIN_ACTIVE_AND_CLOSED_BORROWINGS_PROFILE
                  ? "active"
                  : ""
                  }`}
              >
                <span className="span_icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="14.5"
                      cy="7.5"
                      r="4.75"
                      stroke="white"
                      strokeOpacity="0.5"
                      strokeWidth="1.5"
                    />
                    <circle
                      cx="6"
                      cy="16"
                      r="3.25"
                      stroke="white"
                      strokeOpacity="0.5"
                      strokeWidth="1.5"
                    />
                    <circle
                      cx="16"
                      cy="19"
                      r="2.25"
                      stroke="white"
                      strokeOpacity="0.5"
                      strokeWidth="1.5"
                    />
                  </svg>
                </span>
                <span className="span_text">
                  Active & Closed Borrowings
                </span>
              </div>
            </Link>
            <Link to={SUPER_ADMIN_TRANSACTION} className="side_menu ">
              <div
                className={`list ${PATH_WIN === SUPER_ADMIN_TRANSACTION ||
                  PATH_WIN.slice(0, 33) === SUPER_ADMIN_TRANSACTION_PROFILE ? "active" : ""
                  }`}
              >
                <span className="span_icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.13086 7.56515H19.0961M15.5483 3.13037L19.983 7.56515L15.5483 11.9999M20.87 16.4347H4.90477M8.4526 11.9999L4.01782 16.4347L8.4526 20.8695"
                      stroke="white"
                      strokeOpacity="0.5"
                      strokeWidth="2"
                    />
                  </svg>
                </span>
                <span className="span_text">
                  Transactions
                </span>
              </div>
            </Link>

            <Link
              className="side_menu "
              to={SUPER_ADMIN_SUB_ADMIN_CUSTOMER_MANAGEMENT}
            >
              <div
                className={`list ${PATH_WIN === SUPER_ADMIN_SUB_ADMIN_CUSTOMER_MANAGEMENT ||
                  PATH_WIN.slice(0, 30) === SUPER_ADMIN_SUB_ADMIN_PROFILE_ID ||
                  PATH_WIN.slice(0, 27) ===
                  SUPER_ADMIN_EDIT_SUB_ADMIN_PROFILE_ID ||
                  PATH_WIN === SUPER_ADMIN_CREATE_SUB_ADMIN_PROFILE
                  ? "active"
                  : ""
                  }`}
              >
                <span className="span_icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4 22C4 19.8783 4.84285 17.8434 6.34315 16.3431C7.84344 14.8429 9.87827 14 12 14C14.1217 14 16.1566 14.8429 17.6569 16.3431C19.1571 17.8434 20 19.8783 20 22H18C18 20.4087 17.3679 18.8826 16.2426 17.7574C15.1174 16.6321 13.5913 16 12 16C10.4087 16 8.88258 16.6321 7.75736 17.7574C6.63214 18.8826 6 20.4087 6 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11Z"
                      fill="white"
                      fillOpacity="0.5"
                    />
                  </svg>
                </span>
                <span className="span_text">
                  Sub-Admin Management
                </span>
              </div>
            </Link>

            <Link to={SUPER_ADMIN_COMMISSION_MANAGMENT} className="side_menu ">
              <div
                className={`list ${PATH_WIN === SUPER_ADMIN_COMMISSION_MANAGMENT ? "active" : ""
                  }`}>
                <span className="span_icon">
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 20.6509C4.477 20.6509 0 16.1739 0 10.6509C0 5.12788 4.477 0.650879 10 0.650879C15.523 0.650879 20 5.12788 20 10.6509C20 16.1739 15.523 20.6509 10 20.6509ZM10 18.6509C12.1217 18.6509 14.1566 17.808 15.6569 16.3077C17.1571 14.8074 18 12.7726 18 10.6509C18 8.52915 17.1571 6.49432 15.6569 4.99402C14.1566 3.49373 12.1217 2.65088 10 2.65088C7.87827 2.65088 5.84344 3.49373 4.34315 4.99402C2.84285 6.49432 2 8.52915 2 10.6509C2 12.7726 2.84285 14.8074 4.34315 16.3077C5.84344 17.808 7.87827 18.6509 10 18.6509ZM6.5 12.6509H12C12.1326 12.6509 12.2598 12.5982 12.3536 12.5044C12.4473 12.4107 12.5 12.2835 12.5 12.1509C12.5 12.0183 12.4473 11.8911 12.3536 11.7973C12.2598 11.7036 12.1326 11.6509 12 11.6509H8C7.33696 11.6509 6.70107 11.3875 6.23223 10.9186C5.76339 10.4498 5.5 9.81392 5.5 9.15088C5.5 8.48784 5.76339 7.85195 6.23223 7.38311C6.70107 6.91427 7.33696 6.65088 8 6.65088H9V4.65088H11V6.65088H13.5V8.65088H8C7.86739 8.65088 7.74021 8.70356 7.64645 8.79733C7.55268 8.89109 7.5 9.01827 7.5 9.15088C7.5 9.28349 7.55268 9.41066 7.64645 9.50443C7.74021 9.5982 7.86739 9.65088 8 9.65088H12C12.663 9.65088 13.2989 9.91427 13.7678 10.3831C14.2366 10.852 14.5 11.4878 14.5 12.1509C14.5 12.8139 14.2366 13.4498 13.7678 13.9186C13.2989 14.3875 12.663 14.6509 12 14.6509H11V16.6509H9V14.6509H6.5V12.6509Z"
                      fill="white"
                      fillOpacity="0.5"
                    />
                  </svg>
                </span>
                <span className="span_text">
                  Commission Management
                </span>
              </div>
            </Link>

            <Link to={SUPER_ADMIN_ACTIVITY_LOG} className="side_menu ">
              <div
                className={`list ${PATH_WIN === SUPER_ADMIN_ACTIVITY_LOG ? "active" : ""
                  }`}
              >
                <span className="span_icon">
                  <svg
                    width="22"
                    height="21"
                    viewBox="0 0 22 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21 10.6509H17L14 19.6509L8 1.65088L5 10.6509H1"
                      stroke="white"
                      strokeOpacity="0.5"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span className="span_text">
                  Activity Log
                </span>
              </div>
            </Link>

            <Link to={"#"} className="side_menu ">
              <div className="list ">
                <span className="span_icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                  >
                    <path
                      d="M17 0C17.552 0 18 0.448 18 1V4.757L16 6.757V2H2V18H16V15.242L18 13.242V19C18 19.552 17.552 20 17 20H1C0.448 20 0 19.552 0 19V1C0 0.448 0.448 0 1 0H17ZM18.778 6.808L20.192 8.222L12.414 16L10.998 15.998L11 14.586L18.778 6.808ZM10 10V12H5V10H10ZM13 6V8H5V6H13Z"
                      fill="white"
                      fillOpacity="0.5"
                    />
                  </svg>
                </span>
                <span className="span_text">
                  Content Management
                </span>
              </div>
            </Link>

            <Link to={SUPER_ADMIN_COLLATERAL_MANAGEMENT} className="side_menu ">
              <div
                className={`list ${PATH_WIN === SUPER_ADMIN_COLLATERAL_MANAGEMENT
                  ? "active"
                  : " "
                  } `}
              >
                <span className="span_icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="20"
                    viewBox="0 0 18 20"
                    fill="none"
                  >
                    <path
                      d="M11 6V2H2V18H16V7H13V11.62C13 12.464 12.554 13.253 11.813 13.721L9 15.498L6.187 13.72C5.446 13.253 5 12.464 5 11.62V6H11ZM18 6V18.993C18.0009 19.1243 17.976 19.2545 17.9266 19.3762C17.8772 19.4979 17.8043 19.6087 17.7121 19.7022C17.6199 19.7957 17.5101 19.8701 17.3892 19.9212C17.2682 19.9723 17.1383 19.9991 17.007 20H0.993C0.729813 20 0.477391 19.8955 0.291196 19.7095C0.105001 19.5235 0.000265042 19.2712 0 19.008V0.992C0 0.455 0.449 0 1.002 0H11.997L18 6ZM7 11.62C7 11.77 7.087 11.924 7.255 12.03L9 13.132L10.745 12.03C10.913 11.924 11 11.77 11 11.62V8H7V11.62Z"
                      fill="white"
                      fillOpacity="0.5"
                    />
                  </svg>
                </span>
                <span className="span_text">
                  Collateral Management
                </span>
              </div>
            </Link>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default SideBar;
